import { Close } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  IconButton,
  List,
  ListItemButton,
  Toolbar,
  Typography,
  Tooltip as Tp,
  TextField,
  Autocomplete,
  MenuItem,
  Checkbox
} from "@mui/material";

import { getUsers } from "api/services/users";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { handleApply, resetState, } from "redux/reducers/expenditureSlice";
import { ResType } from "types";
import { getFilters } from "views/tasks/Filters/getFilters";
import { selectExpenditure } from "redux/reducers/expenditureSlice";
import { handleFieldChange } from "redux/reducers/expenditureSlice";
;

interface IProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}




function AllFiltersDialog({ open, setOpen }: IProps) {
  const dispatch = useDispatch();
  const states = useSelector(selectExpenditure);
  const { data: users, isLoading: userLoading }: ResType = useQuery("users", getUsers, { enabled: open });

  const applyFilters = () => {
    dispatch(handleApply());
    setOpen(false);
  };

  const handleReset = () => {
    dispatch(resetState());
    setOpen(false);
  };


  interface StatusOption {
    name: string;
    value: string;
  };

  const EXPENSE_TYPE_OPTIONS = [
    { name: "Additional Charges", value: "ADDITIONAL" },
    { name: "Pure Agent", value: "PURE_AGENT" }
  ]


  return (
    <Dialog
      sx={{ alignItems: "flex-start", maxHeight: 600 }}
      fullWidth
      maxWidth="sm"
      open={open}
      PaperProps={{
        elevation: 0,
        sx: { display: "flex", flexDirection: "column" },
      }}
    >
      <AppBar
        position="static"
        color="transparent"
        sx={{ boxShadow: "none", borderBottom: "1px solid lightgrey" }}
      >
        <Toolbar sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="subtitle1">Filters</Typography>
          <IconButton onClick={() => setOpen(false)}>
            <Close color="primary" />
          </IconButton>
        </Toolbar>
      </AppBar>

      <>

        <Box sx={{ overflowY: "auto", mt: 2, pt: 1, px: 2, pb: 4, flex: 1 }}>

          <Autocomplete
            id="tags-standard"
            multiple
            options={EXPENSE_TYPE_OPTIONS || []}
            value={states?.selectedFilters?.expenseType || []}
            onChange={(_, value) =>
              dispatch(handleFieldChange({ key: "expenseType", value: value || [] }))
            }
            getOptionLabel={(option) => option.name || ""}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Expense Type"
                variant="outlined"
                size="small"
                fullWidth
                sx={{ mt: 3 }}
              />
            )}
            fullWidth
            size="small"
          />
          <Autocomplete
            id="tags-standard"
            multiple
            onChange={(_, value) => dispatch(handleFieldChange({ key: "users", value: value || [] }))}
            value={states.selectedFilters.users || []}
            options={users?.data || []}
            sx={{ mt: 3 }}
            getOptionLabel={(option: any) => option?.fullName}
            renderInput={(params) => (
              <TextField
                {...params}
                required
                variant="outlined"
                size="small"
                fullWidth
                label="Users"
              />
            )}
          />

        </Box>
      </>
      <AppBar
        position="static"
        color="transparent"
        sx={{ boxShadow: "none", borderTop: "1px solid lightgrey" }}
      >
        <Toolbar sx={{ justifyContent: "flex-end", gap: 2, alignItems: "center" }}>
          <Button onClick={handleReset} variant="outlined" color="secondary">
            Reset
          </Button>
          <Button onClick={applyFilters} variant="contained" color="secondary">
            Apply
          </Button>
        </Toolbar>
      </AppBar>
    </Dialog>
  );
}

export default AllFiltersDialog;